<template>
    <!-- DESC：账号激活页面 -->
    <div class="actacc-container">
        <div class="own-box">
            <img src="../../../public/img/active.svg">
            <div class="desc-succ" v-if="isActacc">
                <div class="text">Account activation successful</div>
                <div class="timer">
                    <el-text class="mx-1">Automatically redirect to login page after {{ cursec }} second...</el-text>
                </div>
            </div>
            <div class="desc-fail" v-else>
                <div class="text">Account activation failed</div>
                <div class="timer">
                    <el-text class="mx-1">Please resend the activation email to your registered email</el-text>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { useRouter, useRoute } from "vue-router"
import request from "../../network/request"
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'

const route = useRoute()
const router = useRouter()
const store = useStore()
const cursec = ref(3)
const isActacc = ref(false)
const succtimer = ref(null)

onMounted(() => {
    // 清除菜单索引
    store.commit('setMenuItemIndex', '')
    // 激活账号
    request.get(`/user/activate?tempidentity=${route.query.code}`).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'account activation successful',
                type: 'success',
            })
            isActacc.value = true
            // 3秒后发送激活邮件
            succtimer.value = setInterval(()=>{
                cursec.value--
                if(cursec.value==0){
                    clearInterval(succtimer.value)
                    router.push("/login")
                }
            },1000)
        } else if (res.code == 400)  {
            ElMessage({
                message: 'account activation failed',
                type: 'warning',
            })
            isActacc.value = false
        }
    })
})



</script>

<style lang="scss">
.actacc-container {
    .own-box {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 15%;
            margin-right: 10px;
        }

        .desc-succ {
            .text {
                font-size: 22px;
                font-weight: 700;
                width: 380px;
                text-align: center;
            }

            .timer {
                width: 380px;
                margin-top: 10px;
                text-align: center;
            }
        }

        .desc-fail {
            .text {
                font-size: 22px;
                font-weight: 700;
                width: 400px;
                text-align: center;
            }

            .timer {
                width: 400px;
                margin-top: 10px;
                text-align: center;
            }
        }
    }
}
</style>